/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ResourceAssignmentState = 'ASSIGNING' | 'ASSIGNED' | 'UNASSIGNING' | 'UNASSIGNED';

export const ResourceAssignmentState = {

    ASSIGNING: 'ASSIGNING' as ResourceAssignmentState,

    ASSIGNED: 'ASSIGNED' as ResourceAssignmentState,

    UNASSIGNING: 'UNASSIGNING' as ResourceAssignmentState,

    UNASSIGNED: 'UNASSIGNED' as ResourceAssignmentState
};

